import React from 'react';
import { Box, Paper, Typography, LinearProgress } from '@mui/material';
import { INK } from '../../utils/commercialColors';

// A labeled progress bar, not a chart - the single sequential blue hue
// (the palette's default) carries magnitude, ink carries the numbers.
export default function GoalProgress({ overview }) {
  if (!overview) return null;
  const { payants_actifs, goal, progress_pct } = overview;

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Objectif {goal.toLocaleString('fr-FR')} établissements
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ flexGrow: 1 }}>
          <LinearProgress
            variant="determinate"
            value={Math.min(progress_pct, 100)}
            sx={{
              height: 14,
              borderRadius: 7,
              backgroundColor: INK.gridline,
              '& .MuiLinearProgress-bar': { backgroundColor: '#2a78d6', borderRadius: 7 },
            }}
          />
        </Box>
        <Typography sx={{ color: INK.primary, fontVariantNumeric: 'tabular-nums', minWidth: 120, textAlign: 'right' }}>
          {payants_actifs.toLocaleString('fr-FR')} / {goal.toLocaleString('fr-FR')}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ color: INK.muted }}>
        {progress_pct}%
      </Typography>
    </Paper>
  );
}
